var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"huePicker",staticClass:"hue-picker",class:{ dragging: _vm.dragging }},[_c('drag-area',{attrs:{"padding-x":"10","padding-y":"4"},on:{"new-pos":_vm.newPos,"drag-start":function($event){_vm.dragging = true},"drag-end":function($event){_vm.dragging = false}}}),_c('div',{staticClass:"marker",style:({
      left: _vm.pos, background: _vm.background })}),_c('div',{staticClass:"hue-picker-back"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }